import React from "react";

import "../components/Discover.css";
import { BsCaretRightFill } from "react-icons/bs";

function Discover() {
  return (
    <>
      <div className="discover-container">
        <div className="discover-content">
          <p>Discover... Techonology... Ideas...</p>
        </div>
        <div className="image"></div>
      </div>
    </>
  );
}

export default Discover;
